const frequencies = [125, 250, 500, 1000, 2000, 3000, 4000, 6000, 8000];

const rightEarColor = '#AF5253';
const leftEarColor = '#638EAB';
const boneConductionColor = '#11874B';

const sides = {
  RE: { key: 'RE', label: 'OD', color: rightEarColor, code: 'OD' },
  LE: { key: 'LE', label: 'OI', color: leftEarColor, code: 'OI' },
};

const conductionTypes = {
  AC: { key: 'AC', label: 'Umbrales Aéreos', code: 'UA' },
  BC: { key: 'BC', label: 'Umbrales Óseos', code: 'UO' },
};

const maskingOptions = {
  masking: {
    value: 'masking',
    label: 'Enmascaramiento',
    tooltip: 'Enmascaramiento',
    suffix: 'E',
  },
  no_hearing: {
    value: 'no_hearing',
    label: 'No responde',
    tooltip: 'No responde',
    suffix: 'NR',
  },
};

const findByCode = (collection, code) =>
  Object.values(collection).find((item) => item.code === code)?.key;

const basicAudiometryConfig = {
  columns: [
    {
      title: conductionTypes.AC.label,
      children: [
        {
          title: sides.RE.label,
          dataIndex: `${conductionTypes.AC.key}_${sides.RE.key}`,
          className: 'RE',
        },
        {
          title: sides.LE.label,
          dataIndex: `${conductionTypes.AC.key}_${sides.LE.key}`,
          className: 'LE',
        },
      ],
    },
  ],
  series: [
    {
      dataKey: 'AC_RE',
      stroke: sides.RE.color,
      dot: { stroke: sides.RE.color, r: 4 },
    },
    {
      dataKey: 'AC_LE',
      stroke: sides.LE.color,
      dot: { stroke: sides.LE.color, r: 4 },
    },
  ],
  averages: [
    {
      title: conductionTypes.AC.label,
      conductionType: conductionTypes.AC.key,
      ranges: [
        {
          label: '500 - 1000 - 2000',
          frequencies: [500, 1000, 2000],
        },
      ],
    },
  ],
};

const completeAudiometryConfig = {
  columns: [
    {
      title: conductionTypes.AC.label,
      children: [
        {
          title: sides.RE.label,
          dataIndex: `${conductionTypes.AC.key}_${sides.RE.key}`,
          className: 'RE',
        },
        {
          title: sides.LE.label,
          dataIndex: `${conductionTypes.AC.key}_${sides.LE.key}`,
          className: 'LE',
          isGroupEnd: true,
        },
      ],
    },
    {
      title: conductionTypes.BC.label,
      children: [
        {
          title: sides.RE.label,
          dataIndex: `${conductionTypes.BC.key}_${sides.RE.key}`,
          className: 'RE',
        },
        {
          title: sides.LE.label,
          dataIndex: `${conductionTypes.BC.key}_${sides.LE.key}`,
          className: 'LE',
        },
      ],
    },
  ],
  series: [
    {
      dataKey: 'AC_RE',
      stroke: sides.RE.color,
      dot: { stroke: sides.RE.color, r: 4 },
    },
    {
      dataKey: 'AC_LE',
      stroke: sides.LE.color,
      dot: { stroke: sides.LE.color, r: 4 },
    },
    {
      dataKey: 'BC_RE',
      stroke: 'none',
      dot: { stroke: sides.RE.color, strokeWidth: 2 },
    },
    {
      dataKey: 'BC_LE',
      stroke: 'none',
      dot: { stroke: sides.LE.color, strokeWidth: 2 },
    },
  ],
  averages: [
    {
      title: conductionTypes.AC.label,
      conductionType: conductionTypes.AC.key,
      ranges: [
        {
          label: '500 - 1000 - 2000',
          frequencies: [500, 1000, 2000],
        },
        {
          label: '1000 - 2000 - 3000 - 4000 - 6000',
          frequencies: [1000, 2000, 3000, 4000, 6000],
        },
      ],
    },
    {
      title: conductionTypes.BC.label,
      conductionType: conductionTypes.BC.key,
      ranges: [
        {
          label: '500 - 1000 - 2000',
          frequencies: [500, 1000, 2000],
        },
        {
          label: '1000 - 2000 - 3000 - 4000 - 6000',
          frequencies: [1000, 2000, 3000, 4000, 6000],
        },
      ],
    },
  ],
};

const bilateralAudiometryConfig = {
  seriesRightEar: [
    {
      dataKey: 'AC_RE',
      stroke: sides.RE.color,
      dot: { stroke: sides.RE.color, r: 4 },
    },
    {
      dataKey: 'BC_RE',
      stroke: 'none',
      dot: { stroke: sides.RE.color, strokeWidth: 2 },
    },
  ],
  seriesLeftEar: [
    {
      dataKey: 'AC_LE',
      stroke: sides.LE.color,
      dot: { stroke: sides.LE.color, r: 4 },
    },
    {
      dataKey: 'BC_LE',
      stroke: 'none',
      dot: { stroke: sides.LE.color, strokeWidth: 2 },
    },
  ],
  averages: [
    {
      title: conductionTypes.AC.label,
      conductionType: conductionTypes.AC.key,
      ranges: [
        {
          label: '500 - 1000 - 2000',
          frequencies: [500, 1000, 2000],
        },
        {
          label: '1000 - 2000 - 3000 - 4000 - 6000',
          frequencies: [1000, 2000, 3000, 4000, 6000],
        },
      ],
    },
    {
      title: conductionTypes.BC.label,
      conductionType: conductionTypes.BC.key,
      ranges: [
        {
          label: '500 - 1000 - 2000',
          frequencies: [500, 1000, 2000],
        },
        {
          label: '1000 - 2000 - 3000 - 4000 - 6000',
          frequencies: [1000, 2000, 3000, 4000, 6000],
        },
      ],
    },
  ],
};

export {
  frequencies,
  rightEarColor,
  leftEarColor,
  boneConductionColor,
  sides,
  conductionTypes,
  maskingOptions,
  findByCode,
  basicAudiometryConfig,
  completeAudiometryConfig,
  bilateralAudiometryConfig,
};
